import { createContext } from "react";
import { SignInOutput } from "aws-amplify/auth";
import { SignUpDto } from "@/lib/lutely-api/gen/dtos/signUpDto";

export interface ApiContextType {
  loginUser: (
    email: string,
    password: string,
    skipNavigation?: boolean,
  ) => Promise<SignInOutput>;
  otcLoginUser: (
    email: string,
    accessToken: string,
    idToken: string,
  ) => Promise<void>;
  signUpUser: (signUpDto: SignUpDto, skipNavigation?: boolean) => Promise<void>;
  logoutUser: () => void;
  isAuthenticated: boolean;
  apiClientConfigured: boolean;
  getTokens: (forceRefresh?: boolean) => Promise<{
    access: string | undefined;
    id: string | undefined;
  }>;
  isAdmin: boolean;
  isPaused: boolean;
  pauseApi: (paused: boolean) => void;
  getRedirectPath: () => {
    pathname: string;
    search: object;
  };
}

const ApiContext = createContext<ApiContextType | undefined>(undefined);

export default ApiContext;
